import React from "react";

// Context to handle user authentication with default values
const AuthContext = React.createContext({
  user: null,
});
export default AuthContext;
